<template>
  <div id="zsteel">
    <el-carousel arrow="never" class="banner">
      <el-carousel-item v-for="item in advertList" :key="item.id">
        <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">
          <el-image fit="cover" :src="item.imageUrl"></el-image>
        </a>
        <el-image v-else fit="cover" :src="item.imageUrl"></el-image>
      </el-carousel-item>
    </el-carousel>
    <div class="container">
      <!-- <p class="page-name">卓钢链-商品列表</p>
      <div class="category">
        <p :class="tab === 2 ? '' : 'active'" @click="changeTab(15)">帮卖</p>
        <p :class="tab === 2 ? 'active' : ''" @click="changeTab(2)">撮合</p>
      </div>
      <div class="variety">
        <p class="variety-sub">品类:</p>
        <div class="variety-list">
          <p :class="cateValue.cateCode ? 'variety-item' : 'variety-item active'" @click="reset">全部</p>
          <p v-for="(item, index) in cateList" :key="item.cateCode + index"
            :class="cateValue.cateCode === item.cateCode ? 'variety-item active' : 'variety-item'"
            @click="chooseCate(item)">
            {{ item.categoryName }}
          </p>
        </div>
      </div> -->

      <div class="tab-img">
        <router-link class="tab-img-a" to="/datacenter/peasants">
          <img class="img_0" src="./images/tab_zhongnongwang_0.png" />
          <img class="img_1" src="./images/tab_zhongnongwang_1.png" />
        </router-link>
        <a class="tab-img-a">
          <img class="tab-zhuoganlian" src="./images/tab_zhuoganlian_1.png" />
        </a>
        <router-link class="tab-img-a" to="/datacenter/huasuhui">
          <img class="img_0" src="./images/tab_huasuhui_0.png" />
          <img class="img_1" src="./images/tab_huasuhui_1.png" />
        </router-link>
      </div>
      <div class="tab-header">
        <div class="tab-title">
          <div class="tab-title-pinlei">品类：</div>
          <div class="tab-list">
            <div
              tabindex="1"
              :class="[currentIndex === index ? 'tabItem active' : 'tabItem']"
              @click="clickCate(item, index)"
              v-for="(item, index) in cateList"
              :key="index"
            >
              {{ item.categoryName }}
            </div>
          </div>
        </div>

        <div class="tab-content">
          <div class="tab-content-header">商品列表</div>
          <img src="@/assets/images/noData.png" class="no_data" v-if="noData" />
          <div class="tab-content-box" v-for="(item, index) in goodsList" :key="index">
            <div class="box-left">
              <img class="tab-content-left" src="@/assets/images/datacenter/img_zhuoganglian2.png" />
              <div class="content-main">
                <div class="main-header">{{ item.goodsName || '商品名称' }}</div>
                <div class="main-sub">
                  <span>{{ item.categoryName }}</span>
                  <div class="main-sub-line">|</div>
                  <span>{{ item.specifications }}</span>
                  <div class="main-sub-line">|</div>
                  <span>{{ item.materialName }}</span>
                  <div class="main-sub-line" v-if="item.baleNum">|</div>
                  <span v-if="item.baleNum">{{ item.baleNum }}</span>
                </div>
                <div>
                  <span class="main-zhongliang-title">件重：{{ item.averageQty }}</span>
                  <span class="main-zhongliang-title">库存：共{{ item.canUseStock }}</span>
                  <span class="main-zhongliang-title">总量：{{ item.qty }} </span>
                </div>
                <div class="main-footer">
                  <img class="main-footer-icon" src="@/assets/images/location.png" />
                  <span>{{ item.areaName || '面议' }}</span>
                  <span class="main-footer-span-sub"> {{ item.brand }}</span>
                  <img class="main-footer-icon" src="./images/icon_cangku@2x.png" />
                  <span>{{ item.whName || '面议' }}</span>
                </div>
              </div>
            </div>
            <div class="box-right">
              <div class="box-right-price">
                {{ parseInt(item.price || 0) == 0 ? '价格面议' : item.price }}
                <span class="box-right-yuan" v-if="parseInt(item.price || 0) != 0">元/吨</span>
                <span class="box-right-yuan" v-else></span>

                <span class="box-right-guobang">{{ item.weightWay }}</span>
              </div>
              <div class="box-right-sub">价格更新时间：{{ item.lastOnLineDate }}</div>
              <div class="box-right-buy">
                <img class="box-right-buy-icon" src="./images/icon_lainxi@2x.png" />
                <a href=" https://www.zallsteel.com/mall/index" target="_blank" style="color: #fff">联系购买</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="total > 10" class="pagination">
        <el-pagination
          background
          :current-page="page"
          :total="total"
          layout="prev, pager, next"
          @current-change="onCurChange"
        >
        </el-pagination>
      </div>
    </div>
    <MessageBoard v-if="isShow" :isShow="isShow" @submit="onSubmit" @cancel="onCancel"></MessageBoard>
  </div>
</template>

<script>
import { getBanner, getHwOrderList, intentionInfoAdd, zgCate, zgGoods } from '@/api';
import MessageBoard from '@/components/MessageBoard';
import dayjs from 'dayjs';
export default {
  components: {
    MessageBoard,
  },
  data() {
    return {
      formData: {
        cn: '',
        ph: '',
        mk: '',
      },
      orderParam: {
        total: 0,
        page: 1,
        rows: 20,
        pn: '', // 品名
        sc: '', // 型号
      },
      total: 0,
      cateList: [
        {
          categoryCode: '',
          categoryName: '全部',
        },
        {
          categoryCode: '热轧卷板 ',
          categoryName: '热轧卷板 ',
        },
        {
          categoryCode: '带钢',
          categoryName: '带钢',
        },
        {
          categoryCode: '冷轧',
          categoryName: '冷轧',
        },
        {
          categoryCode: '中厚板',
          categoryName: '中厚板',
        },
        {
          categoryCode: '镀锌',
          categoryName: '镀锌',
        },
        {
          categoryCode: '建筑钢材',
          categoryName: '建筑钢材',
        },
        {
          categoryCode: '型钢',
          categoryName: '型钢',
        },
        {
          categoryCode: '钢坯',
          categoryName: '钢坯',
        },
        {
          categoryCode: '管材',
          categoryName: '管材',
        },
        {
          categoryCode: '优特钢',
          categoryName: '优特钢',
        },
        {
          categoryCode: '生铁及铁合金',
          categoryName: '生铁及铁合金',
        },
        {
          categoryCode: '炉料',
          categoryName: '炉料',
        },
        {
          categoryCode: '电镀锌',
          categoryName: '电镀锌',
        },
      ],
      goodsList: [
        {
          name: '',
        },
      ],
      listParams: {
        currentPage: 1,
        pageSize: 10,
        firstCategoryName: '',
      },

      currentIndex: 0,
      subIndex: 0,
      dialogVisible: false,
      orderList: [],
      orderData: {}, // 订单数据
      boardData: {}, // 留言数据
      advertList: [],
      showMessageBoard: false,
      loading: true,
      prodinfo: {},
      tab: 15,
      isShow: false,
      list: [],
      total: 0,
      page: 1,
      cateValue: {
        categoryName: '全部分类',
        cateCode: '',
      },
      noData: false,
    };
  },
  created() {
    this.getBannerList();
    //this.getOrderList();
    //this.getCate();
    this.getList();
  },
  methods: {
    async getCate() {
      const ret = await zgCate({});
      if (ret.code === 100000) {
        ret.data.forEach((item) => {
          this.cateList.push(item);
        });
      }
    },
    async getList() {
      this.loading = true;
      const ret = await zgGoods(this.listParams);
      this.loading = false;
      this.total = ret.data.total;
      if (ret.code === 100000) {
        ret.data.rows.forEach((item) => {
          if (item.lastOnLineDate) {
            item.lastOnLineDate = dayjs(parseInt(item.lastOnLineDate)).format('YYYY-MM-DD');
          }
        });
        this.goodsList = ret.data.rows;
        this.noData = this.goodsList.length ? false : true;
      }
    },
    onCurChange(curPage) {
      this.listParams.currentPage = curPage;
      this.getList();
      document.body.scrollTop = document.documentElement.scrollTop = 560;
    },
    clickCate(item, index) {
      this.currentIndex = index;
      this.listParams.firstCategoryName = item.categoryCode;
      this.listParams.currentPage = 1;
      this.getList();
    },
    subClick(index) {
      this.subIndex = index;
    },
    handlebuy(item) {
      this.isShow = true;
      this.prodinfo = {
        pf: 1,
        pc: item.orId,
        pn: item.factoryName + ', ' + item.thirdCategoryName + ', ' + item.specName + ', ' + item.materialName,
      };
    },
    getBannerList() {
      getBanner({ page: 1, path: 'platform', uc_to: '' }).then((res) => {
        let { content } = res.data;
        if (Array.isArray(content) && content.length) {
          this.advertList = content[0][0].data.advertList;
        }
      });
    },
    // getOneCategory() {
    //   getOneCategory({ pl_code: 'zgl' }).then((res) => {
    //     this.cateList = res.data;
    //   });
    // },
    findListByDTO() {
      const params = {
        page: this.page,
        rows: 10,
        b_ty: this.tab,
        f_code: this.cateValue.cateCode,
      };
      findListByDTO(params).then((res) => {
        this.list = res.data.rows;
        this.total = res.data.total;
      });
    },
    changeTab(tab) {
      this.page = 1;
      this.tab = tab;
      this.findListByDTO();
    },
    chooseCate(item) {
      this.page = 1;
      this.cateValue = item;
      this.findListByDTO();
    },
    reset() {
      this.cateValue = {
        name: '全部分类',
        code: '',
      };
      this.findListByDTO();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.findListByDTO();
      document.body.scrollTop = document.documentElement.scrollTop = 560;
    },
    onSubmit(val) {
      this.formData = val;
      this.intentionInfoAdd();
    },
    onCancel() {
      this.isShow = false;
    },
    onSearch() {
      this.orderParam.page = 1;
      this.getOrderList();
    },
    intentionInfoAdd() {
      /**
       * let postData = {
       *   cn: '联系人',
       *   ph: '联系人手机号码',
       *   pf: '平台1卓钢链 2中农 3化塑汇',
       *   pc: '商品code',
       *   pn: '名称（根据平台不同，名称由各个平台的商品不同属性组合而成，逗号拼接）',
       *   mk: '备注',
       * };
       */
      let { name: cn, tel: ph, remark: mk = '' } = this.boardData;
      let { prodCode: pc = '', specification = '', prodName = '' } = this.orderData;
      let postData = { cn, ph, pf: 3, pc, pn: prodName + ', ' + specification, mk };
      intentionInfoAdd(postData).then((res) => {
        if (res.status) {
          this.$message.success('咨询意向单提交成功');
          this.showMessageBoard = false;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    getOrderList() {
      let postData = { ...this.orderParam };
      getHwOrderList(postData).then((res) => {
        if (res.status) {
          let { total, rows } = res.data;
          // 总页数
          this.orderParam.total = total;
          // 拼接数据
          this.orderList = rows;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#zsteel {
  .banner {
    width: 100%;
    min-width: 1180px;
    height: 500px;

    ::v-deep .el-carousel__container {
      width: 100%;
      height: 100%;
    }

    .el-image {
      width: 100%;
      height: 500px;
    }
  }

  .container {
    margin-top: 24px;
  }

  .page-name {
    height: 60px;
    font-weight: bold;
    line-height: 60px;
  }

  .category {
    display: flex;
    align-items: flex-end;
    height: 55px;
    padding-left: 170px;
    background: rgba(179, 203, 243, 0.32);

    p {
      width: 96px;
      height: 50px;
      margin-right: 10px;
      font-size: 16px;
      line-height: 50px;
      text-align: center;
      cursor: pointer;

      &.active {
        font-weight: bold;
        color: #0174ff;
        background: #fff;
      }
    }
  }

  .variety {
    box-sizing: border-box;
    display: flex;
    padding: 15px 0 0 30px;
    font-size: 16px;
    background: #fff;
    box-shadow: inset 0 -1px 0 0 #eee, inset 1px 0 0 0 #eee, inset -1px 0 0 0 #eee;

    &-sub {
      width: 70px;
    }

    &-list {
      display: flex;
      flex-wrap: wrap;
    }

    &-item {
      margin-bottom: 15px;
      margin-left: 50px;
      cursor: pointer;

      &.active {
        font-weight: bold;
        color: #0174ff;
      }
    }

    &-name-total {
      display: flex;
      justify-content: space-between;
      height: 40px;
      margin-top: 20px;
      box-shadow: 0 1px 0 0 #eaeaea;
    }

    &-name {
      font-size: 22px;
      font-weight: bold;
      line-height: 40px;
    }

    &-total {
      color: #0076ff;
    }
  }

  .list {
    .item {
      position: relative;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      min-height: 130px;
      padding: 10px 0 10px 14px;
      margin-top: 20px;
      cursor: pointer;
      background: #fff;
      border: 1px solid #eaeaea;
      border-radius: 4px;

      &::before {
        position: absolute;
        top: 0;
        left: 0;
        width: 4px;
        height: 100%;
        content: '';
        background: #7996f5;
        border-radius: 4px 0 0 4px;
      }

      .info-title {
        font-size: 16px;
        line-height: 20px;
      }

      &:hover {
        box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1), 0 -4px 5px 0 rgba(0, 0, 0, 0.1);

        .info-title {
          color: #7996f5;
        }
      }
    }

    .info {
      width: 1016px;
      min-height: 110px;
    }

    .operation {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 140px;
      height: 100%;
      min-height: 110px;
      box-shadow: -1px 0 0 0 #e9ebf0;
    }

    .contact {
      width: 120px;
      height: 38px;
      line-height: 38px;
      color: #fff;
      text-align: center;
      background: #7996f5;
      border-radius: 2px;
    }

    .info-top {
      display: flex;
      justify-content: space-between;
    }

    .info-top-left {
      width: 735px;
      min-height: 60px;
    }

    .info-company {
      margin-top: 10px;
      color: #2eb6aa;

      .addr {
        margin-right: 10px;
        margin-left: 5px;
      }

      .compony-name {
        position: relative;
        padding-left: 12px;
        color: #333;

        &::before {
          position: absolute;
          top: 1px;
          left: 0;
          width: 2px;
          height: 18px;
          content: '';
          background: #eaeaea;
        }
      }
    }

    .info-top-right {
      height: 60px;
      line-height: 60px;

      .price {
        font-size: 18px;
        color: #f7b500;
      }
    }

    .info-bottom {
      height: 40px;
      padding-left: 10px;
      margin-top: 10px;
      line-height: 40px;
      background: #f7fafd;

      .name {
        margin-left: 30px;
        color: #81899e;

        &:nth-child(1) {
          margin-left: 0;
        }
      }
    }
  }

  .pagination {
    padding: 20px 0 30px 0;
    text-align: center;
  }

  .popup {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);

    .popup_box {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 640px;
      height: 420px;
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);
      transform: translate(-50%, -50%);
    }

    .title {
      position: relative;
      height: 55px;
      padding-left: 24px;
      line-height: 55px;
      box-shadow: 0 1px 0 0 #eee;
    }

    .close {
      position: absolute;
      top: 0;
      right: 0;
      width: 55px;
      height: 55px;
      line-height: 55px;
      text-align: center;
      cursor: pointer;
    }

    .form {
      padding-top: 30px;
    }

    .form_row {
      display: flex;
      height: 32px;
      padding-left: 20px;
      margin-top: 24px;
      line-height: 32px;

      &:nth-child(1) {
        margin-top: 0;
      }

      /deep/ .el-input {
        width: 376px;
      }

      /deep/ .el-input__inner {
        width: 376px;
        height: 32px;
      }

      /deep/ .el-textarea {
        width: 376px;
      }

      /deep/ .el-textarea__inner {
        width: 376px;
        height: 130px;
      }

      .label {
        width: 128px;
        height: 32px;
      }
    }

    .submit_box {
      padding: 15px 24px;
      margin-top: 30px;
      text-align: right;
      box-shadow: 0 -1px 0 0 #eee;
    }
  }

  .tab-img {
    display: flex;

    .tab-img-a {
      display: flex;
      border: 1.5px dotted #ececec;
      margin-right: 8px;
      cursor: pointer !important;

      .img_1 {
        display: none;
      }

      .tab-zhuoganlian {
        border: 1.5px dotted #7f97ee;
        box-shadow: 0px 2px 6px 0px rgba(127, 151, 238, 0.5);
      }
    }

    .tab-img-a:focus {
      border: 1.5px dotted #7f97ee;
      box-shadow: 0px 2px 6px 0px rgba(127, 151, 238, 0.5);
    }

    .tab-img-a:hover {
      border: 1.5px dotted #7f97ee;
      box-shadow: 0px 2px 6px 0px rgba(127, 151, 238, 0.5);
      cursor: default;
    }

    .tab-img-a:focus .img_1,
    .tab-img-a:hover .img_1 {
      display: block;
    }

    .tab-img-a:hover .img_0 {
      display: none;
    }

    .tab-img-a:focus .img_0 {
      display: none;
    }

    .tab-zhuoganlian {
      border: 1.5px dotted #7f97ee;
      box-shadow: 0px 2px 6px 0px rgba(127, 151, 238, 0.5);
    }
  }

  .tab-header {
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    font-size: 16px;
    cursor: default;
    padding-top: 21px;

    .tab-title {
      display: flex;
      align-content: center;
      border-bottom: 1px solid #ececec;
      padding-bottom: 37px;

      .tab-title-pinlei {
        font-weight: bold;
        color: #666666;
      }

      .tab-list {
        display: flex;
        // flex-direction: column;

        .tabItem {
          padding: 0 0 0 32px;
          box-sizing: border-box;
          font-weight: 400;
          color: rgba(102, 102, 102, 0.8);
          position: relative;
          cursor: pointer;

          &.active {
            font-weight: bold;
            color: #4870ff;
          }
        }

        .tabItem:focus {
          font-weight: bold;
          color: #4870ff;
        }

        .tabItem:hover {
          font-weight: bold;
          color: #4870ff;
        }
      }
    }

    .tab-content {
      padding-top: 32px;

      .tab-content-header {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
        padding-bottom: 8px;
      }

      .tab-content-box {
        border: 1px solid #ececec;
        padding: 32px 24px;
        margin-bottom: 8px;
        display: flex;
        justify-content: space-between;
        align-content: center;

        .box-left {
          display: flex;
          align-items: center;

          .tab-content-left {
            width: 120px;
            height: 120px;
          }

          .content-main {
            padding-left: 15px;
            font-size: 14px;
            font-weight: 400;
            line-height: 30px;

            .main-header {
              font-weight: bold;
              color: #333333;
              font-size: 20px;
            }

            .main-sub {
              color: #666666;
              display: flex;

              .main-sub-line {
                margin: 0 16px;
                color: #999999;
                widows: 1px;
              }
            }

            .main-zhongliang-title {
              font-weight: 400;
              color: #666666;
              font-size: 14px;
              padding-right: 40px;
            }

            .main-footer {
              color: #7f97ee;
              display: flex;
              align-items: center;

              .main-footer-icon {
                width: 14px;
                height: 14px;
                margin-right: 8px;
              }

              .main-footer-span-sub {
                padding: 0 40px 0 16px;
              }

              .el-icon-location-outline {
                padding-right: 9px;
              }
            }
          }
        }

        .box-right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-weight: bold;
          color: #ffa42a;
          line-height: 24px;
          font-size: 20px;

          .box-right-price {
            font-weight: bold;
            color: #ffa42a;
            font-size: 24px;

            .box-right-yuan {
              font-weight: 400;
              color: #ffa42a;
              font-size: 16px;
              padding: 0 8px 0 2px;
            }

            .box-right-guobang {
              font-weight: 400;
              color: #7f97ee;
              font-size: 16px;
            }
          }

          .box-right-sub {
            font-weight: 400;
            color: #999999;
            font-size: 13px;
          }

          .box-right-buy {
            background: #7f97ee;
            border-radius: 2px;
            padding: 10px 40px;
            margin-top: 10px;
            font-weight: 400;
            color: #ffffff;
            font-size: 14px;
            cursor: pointer;
            display: flex;
            align-items: center;
            .el-icon-shopping-cart-full {
              font-size: 16px;
              padding-right: 8px;
            }

            .box-right-buy-icon {
              width: 16px;
              height: 15px;
              margin-right: 8px;
            }
          }
        }
      }
    }
  }
}

/deep/.el-dialog__body {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 54px 0 69px 0;
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;

  .dialog-content {
    display: flex;
    align-items: center;
    padding-bottom: 12px;

    .dialog-img {
      width: 24px;
      height: 24px;
    }

    .dialog-title {
      font-weight: 400;
      color: #333333;
      font-size: 16px;
      padding-left: 12px;
    }
  }

  .dialog-tel {
    font-weight: 400;
    color: #7f97ee;
    font-size: 20px;
  }

  .dialog-line {
    height: 64px;
  }
}

/deep/ .el-dialog__header {
  font-weight: bold;
  color: #333333;
  font-size: 16px;
  padding: 17px 24px;
}

/deep/.el-dialog__headerbtn .el-dialog__close {
  font-size: 20px;
}

/deep/ .el-dialog__footer {
  padding: 12px 24px;
}

/deep/ .el-button {
  border-radius: 2px;
  padding: 9px 28px;
}
</style>
